import { Component, ViewChild } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../Model/utility/utility.service';
import { Router, RouterModule } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import moment from 'moment';
import { NgSelectModule } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';
import { SessionService } from '../../../Util/Session/session.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
@Component({
  selector: 'app-state-holiday-form',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule],
  templateUrl: './state-holiday-form.component.html',
  styleUrl: './state-holiday-form.component.scss'
})
export class StateHolidayFormComponent {
  SiteHolidayHistoryData = []
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  StateHolidayHistoryData: any[] = [];
  StateData: any[] = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  Years = [] as any;
  filter = {
    SelectType: 1,
    ClientId: null as any,
    StateId: null,
    Year: null,
    TypesOfLeave: null,
    ClientIdObj: null as any,
    HistoryYear: 0
  }
  // Hyear? : string
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    private utility: UtilityService,
    private toast: ToastService,
    private sessionService: SessionService,
    private download: DownloadSampleService,
    protected common: CommonService,
  ) {
    this.common.getPageRights();
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }

  HistoryFilterOnYear() {
    this.GetStateHolidayHistory();
  }

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.filter.HistoryYear = currentYear;
    this.GetStateHolidayHistory();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }
  GetStateHolidayHistory() {
    this.isDisabled = true;
    this.holiday.GetStateHolidayHistory({ SelectType: 1, Year: this.filter.HistoryYear }).subscribe({
      next: (response) => {
        console.log(response);
        this.StateHolidayHistoryData = Object.values(response.Table);
        this.isDisabled = false;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  //Added By Pooja on 10th May 2024 As per discussion with Sakshi 
  handleFileInput(event: any): void {
    this.StateData.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }

  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);
        const uniqueHolidayIds: Set<number> = new Set();
        this.StateData = [];
        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};
          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });
          const id = rowData['ESS_StateHolidayID'];
          const date = rowData['Date'];
          let holidayName = rowData['HolidayName'].toString();
          let stateName = rowData['StateName'].toString();
          let year = rowData['Year'];

          holidayName = holidayName ? holidayName.trim() : '';
          stateName = stateName ? stateName.trim() : '';
          if (id !== 0 && uniqueHolidayIds.has(id)) {
            this.toast.show({ message: `Duplicate StateHoliday ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (year.toString().length != 4 || year === '' || year === null || year === undefined) {
            this.toast.show({ message: `Invalid Year is at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (stateName === '' || stateName === null || stateName === undefined) {
            this.toast.show({ message: `State Name  is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (holidayName === '' || holidayName === null || holidayName === undefined) {
            this.toast.show({ message: `Holiday name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (typeof date !== 'string' || date === undefined || date === null) {
            this.toast.show({ message: `Date Format should be in 'DD MMM YYYY' at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else {
            uniqueHolidayIds.add(id);
          }
          rowData['HolidayName'] = holidayName;
          rowData['StateName'] = stateName;
          rowData['ESS_StateHolidayID'] = id ?? '';
          this.StateData.push(rowData);
        }
        if (this.StateData.length > 0) {
          this.BulkInsertUpdate(this.StateData);
        }
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.StateData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const CompanyHolidayData = {
      SelectType: 'upload',
      ESS_StateHolidayInsert: Data,
      UserId: this.User.UserId,
    };
    this.holiday.BulkStateHolidayInsertUpdate(CompanyHolidayData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.GetStateHolidayHistory();
      },
      error => {
        console.error('Error:', error);
      });
  }

  downloadExcel() {
    this.download.downloadExcel('StateHolidayMaster');
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'StateHolidayExcel',
      Year: this.filter.HistoryYear
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.StateData = data;
        if (this.StateData.length > 0) {
          this.download.exportToExcel(this.StateData, "StateHoliday_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }

      });
  }
}